/**
 * buildInstallerTarget(detail) — derive which Build Installer modal
 * applies to a node. Extracted from NodeDetail.js so the routing
 * contract is unit-testable without mocking the whole node-detail
 * panel.
 *
 *   Returns 'lite'       — open LiteBundleModal
 *           'standalone' — open BuildInstallerModal
 *           null         — hide the Build Installer item entirely
 *
 * Signal precedence (lite-substrate-marker, v0.106.1):
 *   1. detail.substrate === 'lite'       → lite       (persistent stamp)
 *   2. detail.substrate === 'standalone' → standalone (persistent stamp)
 *   3. detail.lite                       → lite       (rendezvous fallback)
 *   4. detail.has_app_identity           → standalone (pre-fix default)
 *   5. (none of the above)               → null       (gate hides item)
 *
 * Why this order: the persistent substrate marker is authoritative —
 * it's set at provision time and doesn't depend on the device being
 * currently REGISTERed. Rendezvous's `lite` flag is only reliable for
 * currently-bound sessions, but it's the only signal we have for
 * pre-fix lite nodes that didn't get the persistent marker. The
 * has_app_identity fallback covers pre-fix standalone nodes
 * (provisioned before v0.106.1's substrate stamping landed).
 */
export function buildInstallerTarget(detail) {
  if (!detail) return null;
  if (detail.substrate === 'lite') return 'lite';
  if (detail.substrate === 'standalone') return 'standalone';
  if (detail.lite) return 'lite';
  if (detail.has_app_identity) return 'standalone';
  return null;
}
